import { connect } from 'react-redux';
import React from 'react';
import branch from 'recompose/branch';
import compose from 'recompose/compose';
import isEmpty from 'lodash/isEmpty';
import renderComponent from 'recompose/renderComponent';
import { t } from '../../../../modules/infra/i18n';
import {
  getDiscountList,
  getMembership,
  getTaxAmount,
  getTaxBreakdown,
  getMembershipDiscountList,
} from '../../validated/selectors';
import { resetOrder, resetMembership } from '../../order/actions';
import OrderInfo from '../components/OrderInfo';
import { getBarbers } from '../../order/selectors';

export default compose(
  connect(
    state => ({
      barbers: getBarbers(state),
      membership: getMembership(state),
      discounts: getDiscountList(state),
      membershipDiscounts: getMembershipDiscountList(state),
      taxAmount: getTaxAmount(state),
      taxBreakdown: getTaxBreakdown(state),
    }),
    { resetOrder, resetMembership }
  ),
  branch(
    props => isEmpty(props.barbers),
    renderComponent(() => <div className="u-p">{t('register:sale.order_info.no_current_sale')}</div>)
  ),
)(OrderInfo);
